import React from "react";
import { CardSimple } from "../../ui";
import {ShareOutlined} from '@mui/icons-material';

export const ShareNotification = ({ albumsList }) => {
    const collaboratorNotSeen = albumsList && albumsList.filter && albumsList.filter(album => album.seen === false).length > 0;

    if(!collaboratorNotSeen) return null;

    return (
        <CardSimple>
            <div className="d-flex justify-content-between align-items-center">
                <ShareOutlined  />
                <div className="text-center pe-2 ps-2">
                    Qualcuno ha condiviso un nuovo album con te, guardalo!
                </div>
                <ShareOutlined  />
            </div>
        </CardSimple>
    )
}